// import "./App.css";
import React, { useEffect, useState } from 'react'
import { Routes, Route, BrowserRouter, Navigate } from 'react-router-dom';
import { useMsal } from "@azure/msal-react";
import { InteractionStatus } from "@azure/msal-browser";
import Dashbord from './pages/Production Schedule';

import Sidebar from './components/Sidebar';
import Projecttype from "./pages/Setting/Projecttype/Projecttype";
import Projectmanager from "./pages/Setting/Projectmanager/Projectmanager";
import Usermodule from "./pages/Setting/User Module/Usermodule";
import Config from "./pages/Setting/Config/Config";
import Actuals from "./pages/Upload/Actuals/Actuals";
import Inbound from "./pages/CRM/Inbound/Inbound";
import Marketing from "./pages/CRM/Marketing/Marketing";
import Actives from "./pages/CRM/Actives/Actives";
import Leads from "./pages/CRM/Leads/Leads";
import Login from "./components/Signin/Login";
import ManageUser from "./components/ManageUser/ManageUser";
import ErrorPage from "./ErrorPage/ErrorPage";
import Project from "./pages/Production/Project/Project";
import Cashfloww from "./pages/Cash-Flow/Cashflow/Cashfloww";
import Projection from "./pages/Cash-Flow/Projection/Projection";
import Summary from "./pages/Cash-Flow/Summary/Summary";
import Billable from "./pages/Upload/billable/Billable";
import BillableConfig from "./pages/Setting/Billable Config/BillableConfig";
import ForgetPassword from "./components/forget-password/forgetPassword";
import ResetPassword from "./components/forget-password/resetPassword";
import PM_TEMPLATE from "./pages/Templates/PM TEMPLATE/PM_TEMPLATE";
import EDIT_PM_TEMPLATE from "./pages/Templates/PM TEMPLATE/EDIT_PM_TEMPLATE";
import INTERIOR_DESIGN_TEMPLATE from "./pages/Templates/INTERIOR DESIGN TEMPLATE/INTERIOR_DESIGN_TEMPLATE";
import Estimating from "./pages/Templates/ESTIMATING/Estimating";
import DEVELOPMENT_MANAGER_TEMPLATE from "./pages/Templates/DEVELOPMENT MANAGER TEMPLATE/DEVELOPMENT_MANAGER_TEMPLATE";
import EditEstimating from "./pages/Templates/ESTIMATING/EditEstimating";
import ESTIMATING_DASHBORD from "./pages/Templates/ESTIMATING/ESTIMATING_DASHBORD";
//*------ Strategic Plan ---------
import BusinessCore from "./pages/Executive Dashboard/Business Core/BusinessCore";
import AccountabilityChart from "./pages/Executive Dashboard/Accountability Chart/AccountabilityChart";
import EsrDashboard from "./pages/Executive Dashboard/ESR Dashboard/EsrDashboard";
//!------ Strategic Plan ---------

import PM_DASHBOARD from "./pages/Templates/PM TEMPLATE/PM_DASHBOARD";
import PmPerformancePoints from "./pages/Templates/PM TEMPLATE/PM PERFORMANCE POINT/PmPerformancePoints";
import PmOverallJobPerformance from "./pages/Templates/PM TEMPLATE/PM OVERALL JOB PERFORMANCE/PmOverallJobPerformance";
import INTERIOR_DESIGN_DASHBOARD from "./pages/Templates/INTERIOR DESIGN TEMPLATE/INTERIOR_DESIGN_DASHBOARD";
import DEVELOPMENT_MANAGER_DASHBOARD from "./pages/Templates/DEVELOPMENT MANAGER TEMPLATE/DEVELOPMENT_MANAGER_DASHBOARD";
import BillableDashboard from "./pages/Billable vs Unbillable/Billable-Dashboard/BillableDashboard";
import BillableYear from "./pages/Billable vs Unbillable/Billable-Year/BillableYear";
import QuarterlyConversation from "./pages/Form/QuarterlyConversation";
import EDIT_INTERIOR_DESIGN_TEMPLATE from "./pages/Templates/INTERIOR DESIGN TEMPLATE/EDIT_INTERIOR_DESIGN";
import Profile from "./pages/Profile/Profile";

import EDIT_All_PLAYBOOKS from "./pages/Templates/PM TEMPLATE/EDIT_ALL_PLAYBOOKS";
import BuilderForm from "./pages/Form/BuilderForm";
import MyPerformanceHuddle from "./pages/Templates/Performance Huddle/My Performance Huddle";
import History from "./pages/Templates/HISTORY/History";
import ArchiveHistory from "./pages/Templates/HISTORY/ArchiveHistory";
import HistoryList from "./pages/Templates/HISTORY/HISTORY LIST/HistoryList";
import Hold from "./pages/CRM/Hold/Hold";
import FormDashboard from "./pages/Form/FormDashboard";
import VpSalesAndMarketing from "./pages/VP SALES & MARKETING/VpSalesAndMarketing";
import HuddlesConversationReports from "./pages/Huddle Quarterly Conversation/Huddles Reports/HuddlesConversationReports";
import Performance from "./pages/Form/Performance";
import FinancialController from "./pages/Financial Controller/FinancialController";
import VpSalesAndMarketingDashboard from "./pages/VP SALES & MARKETING/VpSalesAndMarketingDashboard";
import FinancialControllerDashboard from "./pages/Financial Controller/FinancialControllerDashboard";
import AllPerformanceHuddle from "./pages/All Performance Huddle/All Performance Huddle";
import CostPerSf from "./pages/Templates/COST PER SF/CostPerSf";
import PreConCreep from "./pages/Production/Pre Con Creep/PreConCreep";
import ConstructionCreep from "./pages/Production/Construction Creep/ConstructionCreep";
import EditLeads from "./pages/CRM/Leads/EditLeads";
import OverAllCreep from "./pages/Production/OverAll Creep/OverAllCreep";


import { useSelector, useDispatch } from 'react-redux'

 import ThemeAction from '../src/redux/action/ThemeAction';
import Organization from "./pages/Setting/Org/Organization";
import Layout from "./components/Layout/Layout";
import UserPerformanceHuddle from "./pages/All Performance Huddle/User Performance Huddle";
import Help from "./pages/Help/Help";
import HelpList from "./pages/Help/HelpList";
import PerformanceReviewForm from "./pages/Performance Review/Performance Review Form/PerformanceReviewForm";
import PerformanceReviewHistory from "./pages/Performance Review/Performance Review History/PerformanceReviewHistory";
import MyPerformanceReview from "./pages/Performance Review/My Performance Review/MyPerformanceReview";
import AdminHelp from "./pages/Help/AdminHelp";
import RoleDetails from "./pages/Setting/User Module/RoleDetails";
import LabourFramingCalculator from "./pages/Labour Framing Calculator/LabourFramingCalculator";
import BusinessCore1 from "./pages/Executive Dashboard/Business Core/BusinessCore1";
import MainDashboard from "./pages/Main Dashboard/Main Dashboard";
import CopyUpdateList from "./pages/Templates/COPY UPDATE LIST/CopyUpdateList";
import LeadSourceConfig from "./pages/Setting/Lead Source Config/LeadSourceConfig";
import Log from "./pages/Setting/Log/Log";
import DashbordArchived from "./pages/DashbordArchived";
import MyMails from "./pages/Test/MyMails";





const App = () => {
  const [isLoggedIn, setIsLoggedIn] = useState(false);
  const { instance, inProgress } = useMsal();

  useEffect(() => {
    var storedName = localStorage.getItem('isLogin');
    if (storedName) {
      setIsLoggedIn(storedName);
    }
  }, []);

  useEffect(() => {
    if (inProgress !== InteractionStatus.None) {
      return;
    }

    const authProvider = localStorage.getItem('authProvider');
    const isLogin = localStorage.getItem('isLogin');
    const msAccounts = instance.getAllAccounts();

    // If this session came from Microsoft but MSAL has no active account,
    // force full logout so the app does not silently fall back to local auth.
    if (authProvider === 'microsoft' && isLogin && msAccounts.length === 0) {
      localStorage.clear();
      sessionStorage.setItem('disableMicrosoftAutoLogin', 'true');
      sessionStorage.setItem('msSessionExpiredMessage', 'true');
      window.location.href = '/login';
    }
  }, [instance, inProgress]);

  // useEffect(() => {
  //   const loginTimestamp = localStorage.getItem('loginTimestamp');
  //   const SEVEN_DAYS_MS = 7 * 24 * 60 * 60 * 1000;

  //   if (loginTimestamp) {
  //     const diff = Date.now() - parseInt(loginTimestamp, 10);
  //     if (diff > SEVEN_DAYS_MS) {
  //       localStorage.clear();
  //       window.location.href = '/';
  //     }
  //   }
  // }, []);  

  useEffect(() => {
    const loginTimestamp = localStorage.getItem('loginTimestamp');
    const isLogin = localStorage.getItem('isLogin');
    const SEVEN_DAYS_MS = 7 * 24 * 60 * 60 * 1000;

    // Only clear storage if NOT currently logged in OR if token is truly expired (> 7 days)
    if (!isLogin && (!loginTimestamp || (Date.now() - parseInt(loginTimestamp, 10)) > SEVEN_DAYS_MS)) {
      localStorage.clear();
    }
  }, []);  

  const getData = () => {
    var storedName = localStorage.getItem('isLogin');
    if (storedName) {
      return storedName;
    }
    return false;
  };


  const themeReducer = useSelector(state => state.ThemeReducer)

  const dispatch = useDispatch()

  useEffect(() => {
      const themeClass = localStorage.getItem('themeMode', 'theme-mode-light')

      const colorClass = localStorage.getItem('colorMode', 'theme-mode-light')

      dispatch(ThemeAction.setMode(themeClass))

      dispatch(ThemeAction.setColor(colorClass))
  }, [dispatch])

  return (
    <>
  <BrowserRouter>
  <div className={`${themeReducer.mode} ${themeReducer.color}`}>

      <Routes>
        {getData() ? (
          <>
            <Route path="/error" element={<ErrorPage />} />
            <Route path="/login" element={<Navigate to="/" />} />

            <Route path="/builder-form" element={<BuilderForm />} />
            <Route path="/get-estimate" element={<BuilderForm />} />


            <Route path="*" element={
              <Layout>
                <Routes>
                  {/* <Route path="/" element={<ByDefaultDashboard />} /> */}
                  <Route path="/" element={<MainDashboard />} />
                  {/* <Route path="/" element={<Inbound />} /> */}



                  <Route path="/business-core" element={<BusinessCore1 />} />
                  <Route path="/accountability-chart" element={<AccountabilityChart />} />
                  <Route path="/esr-dashboard" element={<EsrDashboard />} />

                  <Route path="/lead-tracker-dashboard" element={<Inbound />} />
                  <Route path="/marketing" element={<Marketing />} />
                  <Route path="/actives" element={<Actives />} />
                  <Route path="/hold" element={<Hold />} />
                  <Route path="/leads" Component={Leads} />

                  <Route path="/lead-add/" element={<EditLeads />} />
                  <Route path="/lead-edit/:editId" element={<EditLeads />} />

                  <Route path="/production-schedule" element={<Dashbord typeOfData={'production'}/>} />
                  <Route path="/completed-jobs" element={<Dashbord typeOfData={'completed'}/>} />
                  <Route path="/projects-archived" element={<DashbordArchived typeOfData={'archived'}/>} />
                  <Route path="/project" element={<Project />} />

                  <Route path="/summary" element={<Summary />} />
                  <Route path="/Projection" element={<Projection />} />
                  <Route path="/cashflow" element={<Cashfloww />} />
                  <Route path="/labour-framing-calculator" element={<LabourFramingCalculator />} />

                  <Route path="/billable-Dashboard" element={<BillableDashboard />} />
                  <Route path="/billable" element={<Billable />} />
                  <Route path="/billable-year" element={<BillableYear />} />
                  <Route path="/billable-config" element={<BillableConfig />} />

                  <Route path="/pre-con-creep" element={<PreConCreep />} />
                  <Route path="/construction-creep" element={<ConstructionCreep />} />
                  <Route path="/overall-creep" element={<OverAllCreep />} />

                  <Route path="/actuals" element={<Actuals />} />

                  <Route path="/quarterly-huddle-conversation" element={<FormDashboard />} />
                  <Route path="/quarterly-huddle-conversation-history" element={<Performance />} />
                  <Route path="/form/:editId" element={<QuarterlyConversation />} />
                  <Route path="/form" element={<QuarterlyConversation />} />
                  <Route path="/team-score" element={<HuddlesConversationReports />} />

                  <Route path="/performance-review" element={<MyPerformanceReview />} />
                  <Route path="/performance-review-history" element={<PerformanceReviewHistory />} />
                  <Route path="/performance-review-form" element={<PerformanceReviewForm />} />
                  <Route path="/performance-review-form/:editId" element={<PerformanceReviewForm />} />



                  <Route path="/performance-huddle-dashboard" element={<AllPerformanceHuddle />} />
                  <Route path="/performance-huddle-view/:userData" element={<UserPerformanceHuddle/>} />
                  <Route path="/performance-huddle" element={<MyPerformanceHuddle />} />


                  {/* <Route path="/archive-performance-huddle" element={<ArchivePerformanceHuddle />} />
                  <Route path="/archive-performance-huddle-view/:userData" element={<ViewArchivePerformanceHuddle />} />
                  <Route path="/archive-performance-point-view/:type/:id" element={<ViewPerformancePoints />} />
                  <Route path="/finacial-archive-performance-huddle-view/:type/:id" element={<ViewFinancialController />} />
                  <Route path="/sales-archive-performance-huddle-view/:type/:id" element={<ViewVpSalesAndMarketing />} /> */}



                  <Route path="/vp-sales-and-marketing-dashboard" element={<VpSalesAndMarketingDashboard />} />
                  <Route path="/vp-sales-and-marketing" element={<VpSalesAndMarketing />} />
                  <Route path="/vp-sales-and-marketing/view/:viewUserId/:viewRoleId" element={<VpSalesAndMarketing />} />
                  <Route path="/financial-controller-dashboard" element={<FinancialControllerDashboard typeOfData={'financial'} />} />
                  <Route path="/accounting-dashboard" element={<FinancialControllerDashboard typeOfData={'accounting'} />} />

                  <Route path="/financial-controller" element={<FinancialController typeOfData={'financial'} />} />
                  <Route path="/accounting" element={<FinancialController typeOfData={'accounting'} />} />
                  
                  <Route path="/ac-fa-controller/view/:viewUserId/:viewRoleId" element={<FinancialController typeOfData={'view'} />} />


                  <Route path="/pm-performancePoints" element={<PmPerformancePoints />} />
                  <Route path="/pm-OverallJobPerformance" element={<PmOverallJobPerformance />} />


                  <Route path="/playbooks" element={<PM_DASHBOARD />} />
                  <Route path="/view-playbook/:proId" element={<EDIT_All_PLAYBOOKS />} />
                  <Route path="/client-update-history" element={<CopyUpdateList />} />
                  <Route path="/archive-history" element={<History />} />
                  {/* <Route path="/archive-history/:editId" element={<History />} /> */}
                  <Route path="/archive-history-templates/:proId" element={<ArchiveHistory />} />
                  <Route path="/history-list/:projectId/:archiveId" element={<HistoryList />} />
                  {/* <Route path="/history-monthly-view/:archiveId" element={<VIEW_CONSTRUCTION_AND_INTERIOR />} /> */}
                  <Route path="/cost-per-sf" element={<CostPerSf />} />

                  <Route path="/development-manager-template" element={<DEVELOPMENT_MANAGER_TEMPLATE />} />
                  <Route path="/edit-estimating/:editId" element={<EditEstimating />} />
                  <Route path="/edit-pm-template/:editId" element={<EDIT_PM_TEMPLATE />} />
                  <Route path="/edit-interior-design-template/:editId" element={<EDIT_INTERIOR_DESIGN_TEMPLATE />} />


                  <Route path="/config" element={<Config />} />
                  <Route path="/log" element={<Log />} />
                  <Route path="/projecttype" element={<Projecttype />} />
                  <Route path="/usermodule" element={<Usermodule />} />
                  <Route path="/role-details" element={<RoleDetails />} />
                  <Route path="/role-details/:editId" element={<RoleDetails />} />
                  <Route path="/users" element={<Projectmanager />} />
                  <Route path="/projectmanager" element={<Projectmanager />} />
                  <Route path="/organization" element={<Organization />} />
                  <Route path="/lead-source-config" element={<LeadSourceConfig />} />



                  <Route path="/profile" element={<Profile />} />
                  <Route path="/help" element={<Help />} />
                  <Route path="/help-admin/:editId" element={<AdminHelp />} />
                  <Route path="/help-list" element={<HelpList />} />
                  <Route path="/my-mails" element={<MyMails />} />


                  {/* //!-----Unused------------------ */}
                  <Route path="/development-manager-dashboard" element={<DEVELOPMENT_MANAGER_DASHBOARD />} />
                  <Route path="/estimating-dashboard" element={<ESTIMATING_DASHBORD />} />
                  <Route path="/interior-design-dashboard" element={<INTERIOR_DESIGN_DASHBOARD />} />
                  <Route path="/interior-design-template" element={<INTERIOR_DESIGN_TEMPLATE />} />
                  <Route path="/add-interior-design-template" element={<INTERIOR_DESIGN_TEMPLATE />} />

                  <Route path="/manage-user" element={<ManageUser />} />

                  <Route path="*" element={<Navigate replace to="/error" />} />
                </Routes>
              </Layout>
            } />
            <Route path="*" element={<Navigate replace to="/error" />} />
          </>
        ) : (
          <>
            <Route path="/login" element={<Login onLoginSuccess={() => setIsLoggedIn(true)} />} />
            <Route path="*" element={<Navigate replace to="/login" />} />
            {/* ... other routes ... */}
            <Route path="/builder-form" element={<BuilderForm />} />
            <Route path="/get-estimate" element={<BuilderForm />} />
            <Route path="/forget-password" element={<ForgetPassword />} />
            <Route path="/reset-password" element={<ResetPassword />} />
          </>
        )}
      </Routes>
      </div>
    </BrowserRouter>
   
    </>
  )
}

export default App

